var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.isExternalLink ? 'a' : 'RouterLink',{tag:"component",attrs:{"href":_vm.isExternalLink ? _vm.location : undefined,"to":!_vm.isExternalLink ? _vm.location : undefined}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }